import springApi, { getDomain } from '../../services/springApi'

export const getDocuments = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/documents', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getDocument = (id, params) => (
	new Promise((resolve, reject) => {
		springApi()
			.get(`/documents/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeDocument = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/documents', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateDocument = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/documents/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const replaceDocument = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.post(`/documents/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteDocument = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/documents/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchDocuments = async (term, token) => (
	fetch( getDomain()+`/documents?filter[active]=1&filter[title]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(document => ({
				label: document.title,
				value: document.id,
			})),
		)
)